import PropTypes from "prop-types";
import { withAuthGuard } from "src/hocs/with-auth-guard";
import { useSettings } from "src/hooks/use-settings";
import { useSections } from "./config";
import { VerticalLayout } from "./vertical-layout";
import { useStore } from "src/hooks/use-store";
export const Layout = withAuthGuard((props) => {
  const settings = useSettings();
  const sections = useSections();
  const store = useStore();

  return (
    <VerticalLayout
      sections={sections}
      navColor={settings.navColor}
      {...props}
    />
  );
});

Layout.propTypes = {
  children: PropTypes.node,
};
